<mat-card class="new-structure-dialog">
  <!-- Header -->
  <mat-card-header class="header-container">
    <mat-card-title>Create New Structure</mat-card-title>
    <button mat-icon-button (click)="close()"><mat-icon>close</mat-icon></button>
  </mat-card-header>
  <mat-divider></mat-divider>
  <!-- Content -->
  <div class="d-height margin lrg all">
    <!-- New Structure -->
    <form [formGroup]="newStructureForm" autocompete="off" (keyup.enter)="createStructure()">
      <div class="section">
        <h6 class="section-header margin bottom">Structure</h6>

        <!-- Job Name -->
        <div class="row grow full-width">
          <mat-form-field floatLabel="always" appearance="outline" class="three-quarters-width">
            <mat-label
              for="jobName"
              [ngClass]="{
                'error-message': fieldHasError(newStructureForm, 'jobName'),
                focus: focus.jobName
              }"
            >
              Job Name
            </mat-label>

            <div class="row">
              <input
                id="jobName"
                class="uppercase"
                [ngClass]="{
                  error: fieldHasError(newStructureForm, 'jobName'),
                  'focus-border': focus.jobName
                }"
                placeholder="Enter job name"
                formControlName="jobName"
                (focus)="focusOn('jobName')"
                (focusout)="focusOn('jobName')"
                autocomplete="no"
                cdkFocusInitial
                matInput
                aria-describedby="Job name"
              />

              <mat-icon *ngIf="fieldHasError(newStructureForm, 'jobName')" class="error-icon">warning </mat-icon>
            </div>

            <!-- Errors -->
            <div *ngFor="let validation of errorMessages.jobName">
              <div
                class="caption error-message margin lrg top"
                *ngIf="fieldHasErrorMessages(newStructureForm, validation, 'jobName')"
                id="jobNameErrors"
              >
                {{ validation.message }}
              </div>
            </div>
          </mat-form-field>

          <div class="row">
            <mat-checkbox
              class="padding lg left"
              [checked]="isDealerKeySystem"
              (change)="onDealerKeySystemChange()"
            ></mat-checkbox>

            <div for="dealer" class="row padding top">
              Dealer Specified

              <mat-icon
                class="margin left"
                [matTooltip]="
                  'By selecting the checkbox, you are agreeing that the Dealer is providing all the bittings.'
                "
              >
                info_outlined
              </mat-icon>
            </div>
          </div>
        </div>

        <!-- Country -->
        <div class="row full-width">
          <mat-form-field floatLabel="always" appearance="outline" class="margin sm right">
            <mat-label
              for="country"
              [ngClass]="{
                'error-message': fieldHasError(newStructureForm, 'country'),
                focus: focus.country
              }"
            >
              Country
            </mat-label>

            <mat-select
              [ngClass]="{
                error: fieldHasError(newStructureForm, 'country'),
                'focus-border': focus.country
              }"
              (focus)="focusOn('country')"
              (focusout)="focusOn('country')"
              formControlName="country"
            >
              <mat-option *ngFor="let country of countries" [value]="country">
                {{ country.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <!-- City -->
          <mat-form-field floatLabel="always" appearance="outline" class="margin sm left right">
            <mat-label
              for="city"
              class=""
              [ngClass]="{
                'error-message': fieldHasError(newStructureForm, 'city'),
                focus: focus.city
              }"
            >
              City
            </mat-label>

            <div class="row">
              <input
                matInput
                id="city"
                class="uppercase"
                [ngClass]="{
                  error: fieldHasError(newStructureForm, 'city'),
                  'focus-border': focus.city
                }"
                placeholder="Enter city"
                formControlName="city"
                (focus)="focusOn('city')"
                (focusout)="focusOn('city')"
                autocomplete="no"
                cdkFocusInitial
                matInput
                aria-describedby="City errors"
              />

              <mat-icon *ngIf="fieldHasError(newStructureForm, 'city')" [size]="24" class="error-icon"
                >warning
              </mat-icon>
            </div>

            <!-- Errors -->
            <div *ngFor="let validation of errorMessages.city">
              <div
                class="caption error-message margin lrg top"
                *ngIf="fieldHasErrorMessages(newStructureForm, validation, 'city')"
                id="cityErrors"
              >
                {{ validation.message }}
              </div>
            </div>
          </mat-form-field>

          <!-- State -->
          <mat-form-field floatLabel="always" appearance="outline" class="margin sm left">
            <mat-label
              [ngClass]="{
                'error-message': fieldHasError(newStructureForm, 'state'),
                focus: focus.state
              }"
            >
              State
            </mat-label>

            <mat-select
              [ngClass]="{
                error: fieldHasError(newStructureForm, 'state'),
                'focus-border': focus.state
              }"
              (focus)="focusOn('state')"
              (focusout)="focusOn('state')"
              formControlName="state"
              [(value)]="selectedState"
            >
              <mat-option *ngIf="states.length === 0" disabled>
                No states available
              </mat-option>
              <mat-option *ngFor="let state of states" [value]="state">
                {{ state.code }} - {{ state.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div class="section">
        <h6 class="section-header margin bottom">Key System</h6>
        <!-- Keyway Family -->
        <div class="row full-width">
          <mat-form-field floatLabel="always" appearance="outline" class="margin sm right half-width">
            <mat-label
              for="keywayFamily"
              [ngClass]="{
                'error-message': fieldHasError(newStructureForm, 'keywayFamily'),
                focus: focus.keywayFamily
              }"
            >
              Keyway family
            </mat-label>

            <mat-select
              [ngClass]="{
                error: fieldHasError(newStructureForm, 'keywayFamily'),
                'focus-border': focus.keywayFamily
              }"
              (focus)="focusOn('keywayFamily')"
              (focusout)="focusOn('keywayFamily')"
              matNativeControl
              formControlName="keywayFamily"
              [(value)]="selectedKeywayFamily"
            >
              <mat-option *ngFor="let keywayFamily of keywayFamilies" [value]="keywayFamily">
                {{ keywayFamily.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <!-- Combinating Rule Set -->
          <mat-form-field floatLabel="always" appearance="outline" class="margin sm left half-width">
            <mat-label
              for="combinatingRuleSet"
              [ngClass]="{
                'error-message': fieldHasError(newStructureForm, 'combinatingRuleSet'),
                focus: focus.combinatingRuleSet
              }"
            >
              Combinating Rule
            </mat-label>

            <mat-select
              [ngClass]="{
                error: fieldHasError(newStructureForm, 'combinatingRuleSet'),
                'focus-border': focus.combinatingRuleSet
              }"
              (focus)="focusOn('combinatingRuleSet')"
              (focusout)="focusOn('combinatingRuleSet')"
              matNativeControl
              formControlName="combinatingRuleSet"
            >
              <mat-option *ngFor="let combinatingRuleSet of combinatingRuleSets" [value]="combinatingRuleSet">
                {{ combinatingRuleSet.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="row full-width">
          <!-- Chamber Type -->
          <mat-form-field floatLabel="always" appearance="outline" class="margin sm right half-width">
            <mat-label
              for="chamberType"
              [ngClass]="{
                'error-message': fieldHasError(newStructureForm, 'chamberType'),
                focus: focus.combinatingRuleSet
              }"
            >
              Pins/Chambers
            </mat-label>

            <mat-select
              [ngClass]="{
                error: fieldHasError(newStructureForm, 'chamberType'),
                'focus-border': focus.chamberType
              }"
              (focus)="focusOn('chamberType')"
              (focusout)="focusOn('chamberType')"
              matNativeControl
              formControlName="chamberType"
              [(value)]="selectedChamberType"
              [compareWith]="compareObjs"
            >
              <mat-option *ngFor="let chamberType of availableChamberTypes" [value]="chamberType">
                {{ chamberType.description }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <!-- Construction Key Type -->
          <mat-form-field floatLabel="always" appearance="outline" class="margin sm right half-width">
            <mat-label
              for="constructionKeyType"
              [ngClass]="{
                'error-message': fieldHasError(newStructureForm, 'constructionKeyType'),
                focus: focus.constructionKeyType
              }"
            >
              Construction Key Type
            </mat-label>

            <mat-select
              [ngClass]="{
                error: fieldHasError(newStructureForm, 'constructionKeyType'),
                'focus-border': focus.constructionKeyType
              }"
              (focus)="focusOn('constructionKeyType')"
              (focusout)="focusOn('constructionKeyType')"
              matNativeControl
              formControlName="constructionKeyType"
              [(value)]="selectedConstructionKeyType"
            >
              <mat-option
                *ngFor="let constructionKeyType of availableConstructionKeyTypes"
                [value]="constructionKeyType"
              >
                {{ constructionKeyType.description }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <h6 class="section-header margin bottom" *ngIf="!data">Hierarchy</h6>
      <!-- TMK Name -->
      <div *ngIf="!data" class="row full-width">
        <mat-form-field floatLabel="always" appearance="outline" class="margin sm right full-width">
          <mat-label
            for="tmkName"
            [ngClass]="{
              'error-message': fieldHasError(newStructureForm, 'tmkName'),
              focus: focus.tmkName
            }"
          >
            TMK Name
          </mat-label>

          <div class="row">
            <input
              matInput
              autofocus
              id="tmkName"
              [ngClass]="{
                error: fieldHasError(newStructureForm, 'tmkName'),
                'focus-border': focus.tmkName
              }"
              placeholder="Enter TMK Name"
              formControlName="tmkName"
              class="uppercase"
              (focus)="focusOn('tmkName')"
              (focusout)="focusOn('tmkName')"
              autocomplete="no"
              cdkFocusInitial
              matInput
              aria-describedby="tmkName errors"
            />

            <mat-icon *ngIf="fieldHasError(newStructureForm, 'tmkName')" class="error-icon">warning </mat-icon>
          </div>

          <!-- Errors -->
          <div *ngFor="let validation of errorMessages.tmkName">
            <div
              class="caption error-message margin lrg top"
              *ngIf="fieldHasErrorMessages(newStructureForm, validation, 'tmkName')"
              id="tmkNameErrors"
            >
              {{ validation.message }}
            </div>
          </div>
        </mat-form-field>
      </div>
    </form>
  </div>

  <!-- Buttons -->
  <mat-card-actions>
    <div class="row flex-end">
      <button mat-stroked-button id="cancel" (click)="close()">Cancel</button>
      <button
        mat-flat-button
        type="submit"
        (click)="createStructure()"
        class="margin left"
        [ngClass]="{ 'create-button': newStructureForm.valid }"
        [disabled]="!newStructureForm.valid"
        id="create"
      >
        Create Structure
      </button>
    </div>
  </mat-card-actions>
</mat-card>
